import { render, staticRenderFns } from "./HighLightData.vue?vue&type=template&id=6126ac2c&"
import script from "./HighLightData.vue?vue&type=script&lang=js&"
export * from "./HighLightData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports